module.exports = __webpack_public_path__ + "img/usstate.6472756f.jpg";